import * as React from 'react'
import { BREAKPOINT_TABLET_MOBILE, COLORS } from 'static/constants'
import styled from 'styled-components'
import SvgIcon from 'components/atoms/SvgIcon'
import { IconName } from '../../types/icon-names'

export type ArrowStatus = 'up' | 'flat' | 'down' | 'custom'

interface IProps {
  status?: ArrowStatus
  size?: number
  smallSize?: number
  customIcon?: IconName
  label?: string
}

const StatusTip = ({
  status = 'up',
  size = 96,
  smallSize = 47,
  customIcon,
  label,
}: IProps): JSX.Element => {
  const iconName = React.useMemo(() => {
    if (customIcon) {
      return customIcon
    }
    if (status === 'flat') {
      return 'arrow_circle_right'
    }
    if (status === 'down') {
      return 'arrow_circle_down'
    }
    return 'arrow_circle_up'
  }, [status])

  return (
    <Wrapper className={status} size={size} smallSize={smallSize}>
      <SvgIcon name={iconName} className="icon" ariaHidden={true} role="presentation" />
      {label && <div className="label">{label}</div>}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 10px;

  &.up {
    color: ${COLORS.successText};
    background: ${COLORS.successBG};
  }
  &.flat {
    color: ${COLORS.useallyText};
    background: ${COLORS.useallyBG};
  }
  &.down {
    color: ${COLORS.cautionText};
    background: ${COLORS.cautionBG};
  }
  &.custom {
    color: ${COLORS.infoText};
    background: ${COLORS.infoBG};
  }
  > .icon {
    width: ${({ size }) => size / 2}px;
    height: ${({ size }) => size / 2}px;
  }

  .label {
    padding-top: 8px;
    font-size: 14px;
    font-weight: bold;
  }

  @media (max-width: ${BREAKPOINT_TABLET_MOBILE}px) {
    width: ${({ smallSize }) => smallSize}px;
    height: ${({ smallSize }) => smallSize}px;
    > .icon {
      width: ${({ smallSize }) => smallSize / 2}px;
      height: ${({ smallSize }) => smallSize / 2}px;
    }
  }
`
export default StatusTip
